import { SupportTicket } from '@/domains/support';
import { authorizedApi } from '@/services/network/authorized-api';

export const createSupportTicket = (data: SupportTicket) => authorizedApi.post<SupportTicket>(`/v1/help/tickets`, data);
